import { formatDistanceToNow } from 'date-fns';

export function formatDate(date: Date) {
  return new Intl.DateTimeFormat().format(date);
}

export function formatBlogPostDate(date: Date) {
  return new Intl.DateTimeFormat(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}

export function formatRelativeDate(date: Date) {
  return formatDistanceToNow(date, { addSuffix: true });
}
